export const SHARED_CHANGE_TONE_SUBMENU_OPTIONS = [{
  labelKey: 'baseContentGenerationModal.inlineToolbar.options.tones.friendly',
  headerKey: 'baseContentGenerationModal.inlineToolbar.options.tones.friendly',
  parameters: {
    toneOfVoice: 'friendly'
  }
}, {
  labelKey: 'baseContentGenerationModal.inlineToolbar.options.tones.professional',
  headerKey: 'baseContentGenerationModal.inlineToolbar.options.tones.professional',
  parameters: {
    toneOfVoice: 'professional'
  }
}, {
  labelKey: 'baseContentGenerationModal.inlineToolbar.options.tones.witty',
  headerKey: 'baseContentGenerationModal.inlineToolbar.options.tones.witty',
  parameters: {
    toneOfVoice: 'witty'
  }
}, {
  labelKey: 'baseContentGenerationModal.inlineToolbar.options.tones.heartfelt',
  headerKey: 'baseContentGenerationModal.inlineToolbar.options.tones.heartfelt',
  parameters: {
    toneOfVoice: 'heartfelt'
  }
}, {
  labelKey: 'baseContentGenerationModal.inlineToolbar.options.tones.educational',
  headerKey: 'baseContentGenerationModal.inlineToolbar.options.tones.educational',
  parameters: {
    toneOfVoice: 'educational'
  }
}];
export const BRAND_VOICE_CONTENT_TYPES = {
  LANDING_PAGE: 'landing page',
  SITE_PAGE: 'site page',
  BLOG_POST: 'blog post',
  MARKETING_EMAIL: 'marketing email',
  MARKETING_SMS: 'marketing sms message'
};

// Serves as a library of commands that consumer apps pick from when configuring
// the selection command component.
export const SELECTION_COMMANDS = {
  // Blog specific
  BLOG_REPHRASE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    commandId: 'blog_inline_selection_commands_rewrite_v2',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    parameters: {
      voiceChannel: 'BLOG'
    }
  },
  BLOG_EXPAND_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    commandId: 'blog_inline_selection_commands_expand_v2',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    parameters: {
      voiceChannel: 'BLOG'
    }
  },
  BLOG_SUMMARIZE_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    commandId: 'blog_inline_selection_commands_shorten_v2',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    parameters: {
      voiceChannel: 'BLOG'
    }
  },
  BLOG_CHANGE_TONE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    commandId: 'blog_inline_selection_commands_change_tone_v1',
    subMenu: SHARED_CHANGE_TONE_SUBMENU_OPTIONS
  },
  BLOG_BRAND_VOICE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.brandVoice',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.brandVoice',
    beta: true,
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.editBrandVoice_jsx',
    commandId: 'inline_selection_commands_apply_brand_voice_v1',
    parameters: {
      contentType: BRAND_VOICE_CONTENT_TYPES.BLOG_POST
    }
  },
  // CTA specific
  CTA_REPHRASE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    commandId: 'cta_inline_selection_commands_rewrite_v1'
  },
  CTA_EXPAND_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    commandId: 'cta_inline_selection_commands_expand_v1'
  },
  CTA_SUMMARIZE_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    commandId: 'cta_inline_selection_commands_shorten_v1'
  },
  CTA_CHANGE_TONE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    commandId: 'cta_inline_selection_commands_change_tone_v1',
    subMenu: SHARED_CHANGE_TONE_SUBMENU_OPTIONS
  },
  // Pages specific
  PAGES_APPLY_BRAND_VOICE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.brandVoice',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.brandVoice',
    beta: true,
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.editBrandVoice_jsx',
    commandId: 'inline_selection_commands_apply_brand_voice_v1'
  },
  PAGES_REPHRASE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    commandId: 'page_inline_selection_commands_rewrite_v1'
  },
  PAGES_EXPAND_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    commandId: 'page_inline_selection_commands_expand_v1'
  },
  PAGES_SUMMARIZE_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    commandId: 'page_inline_selection_commands_shorten_v1'
  },
  // These are just for the pages app because they use brand voice and BV is not
  // yet supported in the other apps using PAGES_REPHRASE, PAGES_EXPAND_IDEA,
  // and PAGES_SUMMARIZE_IDEA (i.e. GCE, Forms, web interactives)
  PAGES_REPHRASE_V2: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    commandId: 'page_inline_selection_commands_rewrite_v2',
    parameters: {
      voiceChannel: 'PAGES'
    }
  },
  PAGES_EXPAND_IDEA_V2: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    commandId: 'page_inline_selection_commands_expand_v2',
    parameters: {
      voiceChannel: 'PAGES'
    }
  },
  PAGES_SUMMARIZE_IDEA_V2: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    commandId: 'page_inline_selection_commands_shorten_v2',
    parameters: {
      voiceChannel: 'PAGES'
    }
  },
  PAGES_CHANGE_TONE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    commandId: 'page_inline_selection_commands_change_tone_v1',
    subMenu: SHARED_CHANGE_TONE_SUBMENU_OPTIONS
  },
  // Marketing email specific
  MARKETING_EMAIL_REPHRASE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    commandId: 'marketing_email_inline_selection_commands_rewrite_v1'
  },
  MARKETING_EMAIL_EXPAND_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    commandId: 'marketing_email_inline_selection_commands_expand_v1'
  },
  MARKETING_EMAIL_SUMMARIZE_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    commandId: 'marketing_email_inline_selection_commands_shorten_v1'
  },
  MARKETING_EMAIL_CHANGE_TONE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    commandId: 'marketing_email_inline_selection_commands_change_tone_v1',
    subMenu: SHARED_CHANGE_TONE_SUBMENU_OPTIONS
  },
  MARKETING_EMAIL_APPLY_BRAND_VOICE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.brandVoice',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.brandVoice',
    beta: true,
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.editBrandVoice_jsx',
    commandId: 'inline_selection_commands_apply_brand_voice_v1',
    parameters: {
      contentType: BRAND_VOICE_CONTENT_TYPES.MARKETING_EMAIL
    }
  },
  // SMS specific
  SMS_REPHRASE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    commandId: 'sms_inline_selection_commands_rewrite_v1'
  },
  SMS_EXPAND_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    commandId: 'sms_inline_selection_commands_expand_v1'
  },
  SMS_SUMMARIZE_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    commandId: 'sms_inline_selection_commands_shorten_v1'
  },
  SMS_CHANGE_TONE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    commandId: 'sms_inline_selection_commands_change_tone_v1',
    subMenu: SHARED_CHANGE_TONE_SUBMENU_OPTIONS
  },
  SMS_APPLY_BRAND_VOICE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.brandVoice',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.brandVoice',
    beta: true,
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.editBrandVoice_jsx',
    commandId: 'inline_selection_commands_apply_brand_voice_v1',
    parameters: {
      contentType: BRAND_VOICE_CONTENT_TYPES.MARKETING_SMS
    }
  },
  // KB specific
  KB_REPHRASE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.rephrase',
    commandId: 'kb_inline_selection_commands_rewrite_v1'
  },
  KB_EXPAND_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.expand',
    commandId: 'kb_inline_selection_commands_expand_v1'
  },
  KB_SUMMARIZE_IDEA: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.shorten',
    commandId: 'kb_inline_selection_commands_shorten_v1'
  },
  KB_CHANGE_TONE: {
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.changeTone',
    commandId: 'kb_inline_selection_commands_change_tone_v1',
    subMenu: SHARED_CHANGE_TONE_SUBMENU_OPTIONS
  },
  FIX_GRAMMAR: {
    commandId: 'inline_selection_commands_fix_grammar_v1',
    labelKey: 'baseContentGenerationModal.inlineToolbar.options.fixGrammar',
    headerKey: 'baseContentGenerationModal.inlineToolbar.options.fixGrammar'
  }
};

// App-specific configs
export const BLOG_SELECTION_COMMANDS = [SELECTION_COMMANDS.BLOG_REPHRASE, SELECTION_COMMANDS.BLOG_EXPAND_IDEA, SELECTION_COMMANDS.BLOG_SUMMARIZE_IDEA, SELECTION_COMMANDS.BLOG_CHANGE_TONE];
export const BLOG_SELECTION_COMMANDS_WITH_ENABLED_BRAND_VOICE = [SELECTION_COMMANDS.BLOG_BRAND_VOICE, ...BLOG_SELECTION_COMMANDS];
export const BLOG_SELECTION_COMMANDS_WITH_DISABLED_BRAND_VOICE = [Object.assign({}, SELECTION_COMMANDS.BLOG_BRAND_VOICE, {
  disabled: true
}), ...BLOG_SELECTION_COMMANDS];